// RFC 4122 v4 UUID generator that works outside secure contexts.
// crypto.randomUUID is only exposed on HTTPS and trusted localhost, so it is
// missing when the app is served over a plain LAN address (http://192.168.x.x).

const toHex = (bytes) =>
  Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");

const randomBytes = (length) => {
  const bytes = new Uint8Array(length);
  const webCrypto = typeof crypto !== "undefined" ? crypto : null;
  if (webCrypto?.getRandomValues) {
    // getRandomValues is available in insecure contexts as well.
    webCrypto.getRandomValues(bytes);
    return bytes;
  }
  for (let i = 0; i < length; i += 1) {
    bytes[i] = Math.floor(Math.random() * 256);
  }
  return bytes;
};

export const generateUuid = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  const bytes = randomBytes(16);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = toHex(bytes);
  return [
    hex.slice(0, 8),
    hex.slice(8, 12),
    hex.slice(12, 16),
    hex.slice(16, 20),
    hex.slice(20),
  ].join("-");
};

export default generateUuid;
